var _defs, _path, _path2, _path3, _path4, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRobot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Component",
    width: 173.104,
    height: 202.996,
    viewBox: "0 0 173.104 202.996",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls1{fill:#00aae5}\r\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    d: "M476.208 210.208c-8.035 0-14.539 6.079-14.539 13.589s6.5 13.588 14.539 13.588 14.539-6.079 14.539-13.588-6.505-13.589-14.539-13.589zm-.383 21.813c-4.974 0-8.8-3.576-8.8-8.224s3.826-8.225 8.8-8.225 8.8 3.576 8.8 8.225c.383 4.648-3.825 8.224-8.8 8.224z",
    className: "cls1",
    "data-name": "Path 166",
    transform: "translate(-413 -125.166)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    d: "M525.508 210.208c-8.035 0-14.539 6.079-14.539 13.589s6.5 13.588 14.539 13.588 14.539-6.079 14.539-13.588-6.504-13.589-14.539-13.589zm-.383 21.813c-4.974 0-8.8-3.576-8.8-8.224s3.826-8.225 8.8-8.225 8.8 3.576 8.8 8.225c.383 4.648-3.825 8.224-8.8 8.224z",
    className: "cls1",
    "data-name": "Path 167",
    transform: "translate(-413 -125.166)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_52",
    d: "M0 0h48.436v7H0z",
    className: "cls1",
    "data-name": "Rectangle 52",
    transform: "translate(63.772 183.398)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_53",
    d: "M0 0h48.436v7H0z",
    className: "cls1",
    "data-name": "Rectangle 53",
    transform: "translate(63.772 195.997)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    "data-name": "Group 44",
    transform: "translate(-413 -125.166)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    d: "M566.689 177.431h-54.434l7.1-30.441.584-2.5-4.026-.938-.529 2.267-7.371 31.616H492.9l-7.271-31.185-.629-2.7-4.026.938.6 2.585 7.078 30.36h-56.236A19.438 19.438 0 0 0 413 196.847V282.2a19.438 19.438 0 0 0 19.416 19.416h134.273A19.437 19.437 0 0 0 586.1 282.2v-85.353a19.437 19.437 0 0 0-19.411-19.416zM576.7 282.2a10.02 10.02 0 0 1-10.007 10.008H432.416a10.02 10.02 0 0 1-10.008-10.008v-85.353a10.02 10.02 0 0 1 10.008-10.008h134.273a10.02 10.02 0 0 1 10.011 10.008z",
    className: "cls1",
    "data-name": "Path 168"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    d: "M485 143.548l.629 2.7a10.98 10.98 0 0 0 7.2-10.116c0-6.059-5.248-10.964-11.731-10.964s-11.731 4.9-11.731 10.964 5.248 10.963 11.731 10.963c.16 0 .315-.016.474-.022l-.6-2.585zm-11.31-7.418a7.116 7.116 0 0 1 14.2 0c.309 3.75-3.087 6.635-7.1 6.635s-7.1-2.885-7.1-6.635z",
    className: "cls1",
    "data-name": "Path 169"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    d: "M519.936 144.486l-.584 2.5a12.556 12.556 0 0 0 1.524.1c6.483 0 11.731-4.9 11.731-10.963s-5.248-10.964-11.731-10.964-11.73 4.9-11.73 10.964a10.884 10.884 0 0 0 6.235 9.685l.529-2.267zm-6.469-8.356c0-3.751 3.087-6.636 7.1-6.636a6.769 6.769 0 0 1 7.1 6.636c.308 3.75-3.087 6.635-7.1 6.635s-7.1-2.885-7.1-6.635z",
    className: "cls1",
    "data-name": "Path 170"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    "data-name": "Group 45",
    transform: "translate(-413 -125.166)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    d: "M538.423 254.3h-76.167a13.593 13.593 0 0 1-5.074 6.973v.027h86.354a13.591 13.591 0 0 1-5.113-7z",
    className: "cls1",
    "data-name": "Path 171"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    d: "M462.256 254.3a12.731 12.731 0 0 0-1.713-11.074l-4.384 4.384a7.993 7.993 0 0 1 .553 2.922c.382 4.649-3.826 8.225-8.8 8.225a9.807 9.807 0 0 1-2.562-.338l-4.035 4.035a15.279 15.279 0 0 0 6.979 1.666 15.119 15.119 0 0 0 8.888-2.847 13.593 13.593 0 0 0 5.074-6.973z",
    className: "cls1",
    "data-name": "Path 172"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    d: "M559.364 262.452l-4.035-4.035a9.806 9.806 0 0 1-2.562.338c-4.974 0-9.182-3.576-8.8-8.225a7.993 7.993 0 0 1 .553-2.922l-4.384-4.384a12.732 12.732 0 0 0-1.713 11.074 13.591 13.591 0 0 0 5.113 7 15.124 15.124 0 0 0 8.849 2.82 15.279 15.279 0 0 0 6.979-1.666z",
    className: "cls1",
    "data-name": "Path 173"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobot);
export default __webpack_public_path__ + "static/media/robot.af2a4ea9a5d6797e232b4eaff5012e5f.svg";
export { ForwardRef as ReactComponent };